'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { useDragAndDrop } from './file-dropzone.hooks.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { Typography } from '../typography/typography.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { Icon } from '../icon/icon.component.js';

function _object_without_properties(o, e) {
    if (null == o) return {};
    var r, t, n = _object_without_properties_loose(o, e);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(o);
        for(t = 0; t < i.length; t++)r = i[t], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(o, r) && (n[r] = o[r]);
    }
    return n;
}
function _object_without_properties_loose(o, e) {
    if (null == o) return {};
    var r, t, n = {}, i = Object.keys(o);
    for(t = 0; t < i.length; t++)r = i[t], e.indexOf(r) >= 0 || (n[r] = o[r]);
    return n;
}
const FileDropzone = renderWithRef('FileDropzone', null, (n, d)=>{
    useComponentStylesLoaded('FileDropzone', SWAN_STYLE_KEY_MAP.fileDropzone);
    let { children: m, note: f, dropNote: u, multiFileErrorMessage: h } = n, b = _object_without_properties(n, [
        "children",
        "note",
        "dropNote",
        "multiFileErrorMessage"
    ]), w = new Set([
        'swan-file-dropzone'
    ]), y = useRef(null), { isDragging: _, isMultiDropError: z } = useDragAndDrop(y);
    return _ && w.add('swan-file-dropzone-on-drag'), z && w.add('swan-file-dropzone-has-multi-file-error'), jsxs(RenderComp, {
        classNames: w,
        root: "div",
        forwardedRef: assignRefs(d, y),
        props: b,
        children: [
            m,
            jsx(Typography, {
                className: "swan-file-dropzone-note",
                children: f
            }),
            jsxs("div", {
                className: "swan-file-dropzone-drop-note",
                children: [
                    jsx(Icon, {
                        iconType: "add"
                    }),
                    jsx(Typography, {
                        fontSkin: "body-standard-bold",
                        children: u
                    })
                ]
            }),
            jsxs("div", {
                className: "swan-file-dropzone-error-message",
                children: [
                    jsx(Icon, {
                        iconType: "error"
                    }),
                    jsx(Typography, {
                        fontSkin: "body-standard-bold",
                        children: h
                    })
                ]
            })
        ]
    });
});

export { FileDropzone };
